import InfoCard from "../Components/Cards/InfoCard";
import Button from "@mui/material/Button";
import VolunteerActivismIcon from "@mui/icons-material/VolunteerActivism";
import useContentHook from "../hooks/useContentHook";

const DashBoard = () => {
  const { getContentText } = useContentHook();
  // get data from aoi 
  const date = <p> {getContentText("pages_dashBoard_data")}</p>;

  // more details btn 
  const Action = (
    <Button size="small" variant="outlined" sx={{ mx: 1 }}>
      Learn More
    </Button>
  );
  return (
    <>
    {/* show information */}
      <InfoCard
        content={date}
        action={Action}
        icon={<VolunteerActivismIcon />}
      />
      <InfoCard
        content={date}
        action={Action}
        icon={<VolunteerActivismIcon />}
      />
      <InfoCard content={date} icon={<VolunteerActivismIcon />} />
      <InfoCard content={date} />
    </>
  );
};

export default DashBoard;
